import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'sanitizeHtml',
  standalone: true,
})
export class SanitizeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(html) {
    const sanitizedContent = DOMPurify.sanitize(html, {
      ALLOWED_ATTR: ['class', 'id', 'href', 'target', 'title', 'data-*'], // dropped "style"
      ALLOWED_TAGS: ['a', 'b', 'i', 'strong', 'em', 'p', 'div', 'span'], // explicit whitelist
      ALLOWED_URI_REGEXP: /^(https?|mailto):/i, // only allow http, https, mailto
    });

    return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }
}
